export function calculatePercentage(part, total) {
  return total > 0 ? `${((part / total) * 100).toFixed(2)  } %` : '0.00 %';
} 
